import Select from "common/components/Select";
import axios from "common/configs/axiosConfigs";
import { REFERRED_BY_OPTIONS } from "common/constants/enums";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CreateContact = ({ contact }) => {
  const { company_id } = JSON.parse(localStorage.getItem("user-auth"));
  const navigate = useNavigate();
  const FORM_STATE = {
    ...(contact && { contactId: contact?.id, companyId: company_id }),
    action: contact ? "editContact" : "addFullContact",
    honorifics: contact?.honorifics || "mr",
    firstName: contact?.first_name || "",
    lastName: contact?.last_name || "",
    phone: contact?.phone || "",
    email: contact?.email || "",
    address: contact?.address || "",
    alternativeNumber: contact?.alternative_number || "",
    city: contact?.city || "",
    locality: contact?.locality || "",
    pincode: contact?.pincode || "",
    dob: contact?.dob || "",
    company: contact?.company || "",
    bankName: contact?.bank_name || "",
    bankAc: contact?.bank_ac || "",
    bankIfsc: contact?.bank_ifsc || "",
    remarks: contact?.remarks || "",
    referredBy: contact?.refer_by || "Admin",
  };
  const [formState, setFormState] = useState(FORM_STATE);
  useEffect(() => {
    setFormState(FORM_STATE);
  }, [contact]);
  const handleInput = ({ target: { name, value } }) => {
    setFormState((prev) => ({ ...prev, [name]: value }));
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post("", {
        ...formState,
        companyId: company_id,
      });
      if (data?.success) {
        toast.success(data?.msg);
        navigate("/contacts");
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setFormState(FORM_STATE);
    }
  };
  return (
    <section>
      <h4 className="page-title">{contact ? "Edit" : "Create"} Contact</h4>

      <div className="card mt-3">
        <form onSubmit={onSubmit}>
          <h6>CONTACT INFORMATION</h6>
          <div className=" row gy-4">
            <div className="col-md-6">
              <div className="d-flex flex-wrap">
                <span className="label w-100">
                  First name <span className="text-danger">*</span>
                </span>
                <select
                  name="honorifics"
                  value={formState.honorifics}
                  onChange={handleInput}
                  className="form-select w-25 me-2"
                  required
                >
                  <option value="mr">Mr.</option>
                  <option value="ms">Ms.</option>
                  <option value="mrs">Mrs.</option>
                </select>
                <input
                  type="text"
                  name="firstName"
                  value={formState.firstName}
                  onChange={handleInput}
                  className="form-control col"
                  placeholder="First name"
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <label>
                <span className="label">
                  Last name <span className="text-danger">*</span>
                </span>
                <input
                  type="text"
                  name="lastName"
                  value={formState.lastName}
                  onChange={handleInput}
                  className="form-control"
                  placeholder="Last name"
                  required
                />
              </label>
            </div>
            <div className="col-md-6">
              <label>
                <span className="label">
                  Phone <span className="text-danger">*</span>
                </span>
                <input
                  type="tell"
                  pattern="[0-9]{10}"
                  name="phone"
                  value={formState.phone}
                  onChange={handleInput}
                  className="form-control"
                  placeholder="Phone number"
                  required
                />
              </label>
            </div>
            <div className="col-md-6">
              <label>
                <span className="label">Alternative number</span>
                <input
                  type="tell"
                  pattern="[0-9]{10}"
                  name="alternativeNumber"
                  value={formState.alternativeNumber}
                  onChange={handleInput}
                  className="form-control"
                  placeholder="Alternative number"
                />
              </label>
            </div>
            <div className="col-md-6">
              <label>
                <span className="label">Email</span>
                <input
                  type="email"
                  name="email"
                  value={formState.email}
                  onChange={handleInput}
                  className="form-control"
                  placeholder="Email address"
                />
              </label>
            </div>
            <div className="col-md-6">
              <label>
                <span className="label">Date of Birth</span>
                <input
                  type="date"
                  name="dob"
                  value={formState.dob}
                  onChange={handleInput}
                  className="form-control"
                  placeholder="DOB"
                />
              </label>
            </div>
            <div className="col-md-6">
              <label>
                <span className="label">Address</span>
                <input
                  type="text"
                  name="address"
                  value={formState.address}
                  onChange={handleInput}
                  className="form-control"
                  placeholder="Address"
                />
              </label>
            </div>
            <div className="col-md-6">
              <label>
                <span className="label">City</span>
                <input
                  type="text"
                  name="city"
                  value={formState.city}
                  onChange={handleInput}
                  className="form-control"
                  placeholder="City"
                />
              </label>
            </div>
            <div className="col-md-6">
              <label>
                <span className="label">Locality</span>
                <input
                  type="text"
                  name="locality"
                  value={formState.locality}
                  onChange={handleInput}
                  className="form-control"
                  placeholder="Locality"
                />
              </label>
            </div>
            <div className="col-md-6">
              <label>
                <span className="label">Pincode</span>
                <input
                  type="text"
                  name="pincode"
                  value={formState.pincode}
                  onChange={handleInput}
                  className="form-control"
                  placeholder="Pincode"
                />
              </label>
            </div>
            <div className="col-md-6">
              <label>
                <span className="label">
                  Referred by <span className="text-danger">*</span>
                </span>
                <Select
                  options={REFERRED_BY_OPTIONS}
                  name="referredBy"
                  value={formState.referredBy}
                  onChange={handleInput}
                  placeholder="Referred by"
                />
              </label>
            </div>
          </div>
          <h6 className="mt-4">COMPANY INFORMATION</h6>
          <div className="row gy-4">
            <div className="col-lg-6">
              <label>
                <span className="label">Company</span>
                <input
                  type="text"
                  className="form-control"
                  name="company"
                  value={formState.company}
                  onChange={handleInput}
                  placeholder="company"
                />
              </label>
            </div>

            <div className="col-lg-6">
              <label>
                <span className="label">Bank Name</span>
                <input
                  type="text"
                  className="form-control"
                  name="bankName"
                  value={formState.bankName}
                  onChange={handleInput}
                  placeholder="Bank name"
                />
              </label>
            </div>
            <div className="col-lg-6">
              <label>
                <span className="label">Bank Account no.</span>
                <input
                  value={formState.bankAc}
                  onChange={handleInput}
                  type="text"
                  className="form-control"
                  name="bankAc"
                  placeholder="Bank Account no."
                />
              </label>
            </div>
            <div className="col-lg-6">
              <label>
                <span className="label">Bank IFSC Code</span>
                <input
                  value={formState.bankIfsc}
                  onChange={handleInput}
                  type="text"
                  className="form-control"
                  name="bankIfsc"
                  placeholder="Bank IFSC Code"
                />
              </label>
            </div>
            <div className="col-12">
              <label>
                <span className="label">Remark</span>
                <textarea
                  value={formState.remarks}
                  onChange={handleInput}
                  className="form-control"
                  name="remarks"
                  placeholder="Remark"
                />
              </label>
            </div>
          </div>
          <button type="submit" className="btn btn-primary mt-4">
            Submit
          </button>
        </form>
      </div>
    </section>
  );
};

export default CreateContact;
